export const ka = {
  title: 'მიწის საფარი 2015',
  subtitle: 'ESA/UCLouvain, 2015 წ',
  download_data: 'http://maps.elie.ucl.ac.be/CCI/viewer/download.php',
  learn_more: 'http://maps.elie.ucl.ac.be/CCI/viewer/download/ESACCI-LC-Ph2-PUGv2_2.0.pdf',
  content: [
    {
      label: 'ფუნქცია',
      value: 'აჩვენებს მიწის საფარის გლობალურ განაწილებას 2015 წელს',
    },
    {
      label: 'რეზოლუცია',
      value: '300 × 300 მეტრი',
    },
    {
      label: 'გეოგრაფიული გაშუქება',
      value: 'გლობალური',
    },
    {
      label: 'წყარო',
      value: '© ESA კლიმატის ცვლილების ინიციატივა - მიწის საფარი UCLouvain( 2017)',
    },
    {
      label: 'სიხშირე',
      value: 'წლიური',
    },
    {
      label: 'შინაარსის თარიღი',
      value: '2015',
    },
    {
      label: 'გაფრთხილება',
      value:
        'სრული სიზუსტის შეფასება ხელმისაწვდომია CCI– დან. ზოგადად, მიწის საფარის კლასები, როგორიცაა წვიმის და სარწყავი მოსავალი, ფართო ფოთლოვანი მარადმწვანე ტყე, ურბანული ადგილები, შიშველი ადგილები, წყლის ობიექტები და მუდმივი თოვლი საკმაოდ ზუსტად არის მოთავსებული. მეორეს მხრივ, კლასები, როგორიცაა ლიქენები და ხავსები, იშვიათი მცენარეულობა და დატბორილი ტყე სუფთა წყლით, შეიძლება გავლენა იქონიოს შეცდომებმა.\n\nმონაცემთა ხარისხი განსხვავდება რეგიონის მიხედვით, განსაკუთრებით როგორც ეს დაკავშირებულია MERIS გამოსახულების გაშუქებასთან საბაზისო რუკის შესაქმნელად. ნაკლები დაფარვის მქონე ტერიტორიები მოიცავს ამაზონის აუზის დასავლეთ ნაწილს, ჩილეს და არგენტინის სამხრეთ ნაწილს, კონგოს აუზის დასავლეთ ნაწილს, ასევე გვინეას ყურეს, რუსეთის აღმოსავლეთ ნაწილს და ჩინეთისა და ინდონეზიის აღმოსავლეთ სანაპიროს.',
    },
    {
      label: 'ლიცენზია',
      value: 'http://maps.elie.ucl.ac.be/CCI/viewer/download.php',
    },
  ],
  overview: {
    label: 'მიმოხილვა',
    value:
      'ეს მონაცემთა ნაკრები (ვერსია 2.07) შეიქმნა კლიმატის ცვლილების ინიციატივის (CCI) ფარგლებში, ევროპის კოსმოსური სააგენტოს ინიციატივა კლიმატის მოდელირების მიზნით გრძელვადიანი, თანმიმდევრული, გლობალური მონაცემების შესაქმნელად. CCI Land Cover პროექტი აწვდის თანმიმდევრულ გლობალურ მიწის საფარის რუკებს 300 მ სივრცითი რეზოლუციით ყოველწლიურად 1992 წლიდან 2015 წლამდე. Global Forest Watch პლატფორმა აჩვენებს მხოლოდ 2015 წლის მიწის საფარის მონაცემებს.\n\nწლიდან წლამდე თანმიმდევრულობის უზრუნველსაყოფად, ყოველწლიურად მიწის საფარის რუქები გამომდინარეობს ერთი საბაზისო სახმელეთო საფარის რუქიდან. საბაზისო რუკა შეიქმნა MERIS სურათების სრული ჩანაწერის გამოყენებით 2003 წლიდან 2012 წლამდე, უკონტროლო კლასიფიკაციის გამოყენებით, ასევე მანქანური სწავლების ალგორითმის გამოყენებით მრავალი წლის განმავლობაში. შემდეგ ცვლილებები გამოვლინდა ინდივიდუალურ წლებს შორის 1 კმ გარჩევადობით, AVHRR მონაცემების გამოყენებით 1992 წლიდან 1999 წლამდე, SPOT-VGT მონაცემები 1999 წლიდან 2013 წლამდე და PROVA-V მონაცემები 2014 და 2015 წლებში. ცვლილებები უნდა იყოს თანმიმდევრული ზედიზედ ორი წლის განმავლობაში, რათა ჩაითვალოს, გარდა 2014 და 2015 წლებში ტყის ცვლილებებისა, რომლებიც კარგად არის გამოვლენილი. შემდეგ 1 კმ ცვლილებები შერწყმულია მიწის საფარის საბაზისო რუქასთან და 300 მეტრამდე 2004 წლის შემდეგ (როდესაც MERIS და PROVA-V მონაცემები ხელმისაწვდომია).\n\nშედეგად მიღებულ მონაცემებს სულ 22 გლობალური მიწის საფარის კლასი აქვს. უკეთესი ვიზუალიზაციის მიზნით, Global Forest Watch გვიჩვენებს მხოლოდ გამარტივებული კლასების ერთობლიობას, რომელიც დაფუძნებულია IPCC- ზე (სოფლის მეურნეობა, ტყე, ბალახი, ჭაობი, დასახლება, ბუჩქნარი, იშვიათი მცენარეულობა, შიშველი ტერიტორია, წყალი და მუდმივი ყინული და თოვლი). კლასების სრული ნაკრები, ასევე წლიური მიწის საფარის რუკები 1992 წლამდე ხელმისაწვდომია ESA / CCI მაყურებელზე.',
  },
  citation: {
    label: 'ციტატა',
    value:
      'ESA Climate Change Initiative, Land Cover - led by UC Louvain. “2015 global land cover.” Land Cover CCI Product User Guide Version 2. Tech. Rep. (2017). Available at: maps.elie.ucl.ac.be/CCI/viewer/download/ESACCI-LC-Ph2-PUGv2_2.0.pdf. Accessed through Global Forest Watch on 14/02/2025. www.globalforestwatch.org.',
  },
};
